export default "__VITE_ASSET__Cwl1qD52__"